import {myaxios} from '@/network/myAxios'
import store from '@/store'
import router from '@/router'

export const setupInterceptor = () => {
	myaxios.interceptors.response.use(response => {
		if (response.data) {
			// console.log(response.data)
			//if not logged in, check if current page requires auth and redirect to login if it does
			if (response.data.is_logged_in === false){
				let currentRoute = router.currentRoute
				if (currentRoute.matched.some(record => record.meta.requiresLogin)) {
					//redirect to login page
					router.push({ name: 'login', query: { redirect: currentRoute.path, state:"authRequired" }})
				}
			}
			console.log(response.data);
			//update store accordingly
			if ('is_logged_in' in response.data && response.data.is_logged_in !== store.state.auth.loggedIn){
				store.commit("auth/setLoggedIn", response.data.is_logged_in)
				// resetCache()
			}

			//keep track of member level changes
			if ('member_level' in response.data && response.data.member_level !== store.state.auth.memberLevel){
				//console.log("Member level changed to ", response.data.member_level, "  from  ", store.state.auth.memberLevel)
				store.commit("auth/setMemberLevel", response.data.member_level)
			}

			if ('available_silver_memberships' in response.data && response.data.available_silver_memberships !== store.state.auth.available_silver){
				//console.log("Available Silver Members ", response.data.available_silver_memberships)
				store.commit("auth/setAvailableSilver", response.data.available_silver_memberships)
			}

			if('count_members_on_account' in response.data && response.data.count_members_on_account !== store.state.auth.account_count){
				store.commit("auth/setAccountCount", response.data.count_members_on_account)
			}

			if("returns_form" in response.data && response.data.returns_form.success !== store.state.misc.returns_form){
				store.commit("misc/setReturnsForm", response.data.returns_form.success)
				setTimeout(() => {
					store.commit("misc/setReturnsForm", false)
				}, 3000);
			}

			if("canTransact" in response.data && response.data.canTransact !== store.state.canTransact) {
				store.commit("member/setTransactionState", response.data.canTransact);
			}

			if("last_logged_in" in response.data && response.data.last_logged_in !== store.state.last_logged_in) {
				store.commit("member/setLastLoggedin", response.data.last_logged_in);
			}

			if(("price_to_upgrade" in response.data || ("member" in response.data)) && store.state.goldExpiration == null){
				if("member" in response.data && "account_details" in response.data.member) {
					store.commit("member/setGoldExpiration", response.data.member.account_details.account_expiration_date);
				} else if ("price_to_upgrade" in response.data) {
					store.commit("member/setGoldExpiration", response.data.price_to_upgrade.expiry_date);
				}
			}
		}
		return response;
	})
}
